import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ashmttoursimandhospitalitymanagement',
  templateUrl: './ashmttoursimandhospitalitymanagement.component.html',
  styleUrls: ['./ashmttoursimandhospitalitymanagement.component.scss']
})
export class AshmttoursimandhospitalitymanagementComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
